import React, { useState } from 'react';
import './DonationInfo.css';

export const DonationInfo: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="donation-info">
      <button
        type="button"
        className="donation-info__trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        What are donations used for?
      </button>

      {isOpen && (
        <div className="donation-info__content">
          <p>Thanks to your support, we are able to:</p>
          <ul>
            <li>Keep storage and hosting online</li>
            <li>Continuously improve our platform</li>
            <li>Grow a passionate community for game preservation</li>
            <li>Recruit and support contributors for advanced development</li>
          </ul>
          <p className="donation-info__footer">
            Every contribution makes a difference!
          </p>
        </div>
      )}
    </div>
  );
};

export default DonationInfo;
